import User, { defaultAdmin } from '../../models/User'
import env from '../../config/env'
import Audio from './Messages/Audio'
import Document from './Messages/Document'
import Geolocation from './Messages/Geolocation'
import Image from './Messages/Image'
import Text from './Messages/Text'

type MessageType = 'TEXT' | 'AUDIO' | 'IMAGE' | 'DOCUMENT' | 'GEOLOCATION'

export interface Upload {
  id: number
  realty_id?: number
  name: string
  path: string
  url: string
  small: string,
  large: string,
  medium: string,
  tiny: string,
  uploaded_at: string
}

export interface Geolocation {
  latitude: number
  longitude: number
}

export interface MessageCreate {
  content?: string | null
  type: MessageType
  upload?: Upload
  duration?: number
  geolocation?: Geolocation
}

export interface Message {
  id?: number
  is_read?: boolean
  content?: string | null
  type: MessageType
  user?: User
  upload?: Upload
  geolocation?: Geolocation
  created_at?: string
  duration?: number
  user_id?: string
}

export const mapToComponent = {
  TEXT: Text,
  AUDIO: Audio,
  IMAGE: Image,
  DOCUMENT: Document,
  GEOLOCATION: Geolocation,
}

export const welcomeMessage: Message = {
  "id": 0,
  "user": defaultAdmin,
  "type": "TEXT",
  "content": env.defaultWelcomeMessage,
  "is_read": true,
  "created_at": new Date().toString()
} 
